module.exports = __webpack_public_path__ + "static/img/ld-investigate.aa4b926.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/ld-investigate.svg
// module id = ZccG
// module chunks = 12